angular.module('llax')
  .controller('SupplierItemReviewController',
      function ($attrs, $log, $scope, $timeout, $q, CommunicationChannelResource, ContactsResource, GdsnPartiesResource, SupplierReviewResource) {
        var GLN_PATTERN_LENGTH = 13;
        var REVIEW_MESSAGE_MAX_LENGTH = 150;
        var REVIEW_MESSAGE_PROBE_LENGTH = 60;

        $scope.reviews = [];
        $scope.reviewErrors = {};
        $scope.reviewWarnings = {};
        $scope.temporaryModelForPanels = [];
        $scope.expandedReviewMessages = {};
        $scope.gdsnParties = [];
        $scope.showErrors = false;
        $scope.showWarnings = false;
        $scope.VIEW_BY_ERRORS_WARNINGS = 'ByErrorsWarnings';
        $scope.VIEW_BY_REVIEWER = 'ByReviewer';
        $scope.view = $scope.VIEW_BY_REVIEWER;
        $scope.loading = true;

        // Ugly hack: getting dependencies from parent controller if not available in injected $attrs
        $scope.itemPrimaryKey = $attrs.itemPrimaryKey || $scope.item.primaryKey__;
        $scope.publicationDestination = $attrs.publicationDestination;
        $scope.reviewer = $attrs.reviewer;

        $scope.organizations = [];
        $scope.channels = [];

        (function init() {
            // There are 3 possible ways to fetch a reviewer information:
            //  1- If it's an in-platform review i.e. `review.reviewerId` is set, then the reviewer is an active organization.
            //  2- If that wasn't the case, the review might be from one of the communication channels.
            //  3- Communication channels might not define all the sub channels, for example in GDSN. Therefor, if all previous attempts fail,
            //     we try to fetch the information from the available GDSN parties.

            var reqObj = { primaryKey: $scope.itemPrimaryKey };
            if (!_.isNil($scope.publicationDestination)) {
                reqObj.publicationDestination = $scope.publicationDestination;
            }
            if (!_.isNil($scope.reviewer)) {
                reqObj.reviewer = $scope.reviewer;
            }

            SupplierReviewResource.get(reqObj, {},
                function (response) {
                    $scope.reviews = response;
                    $q.all([
                        loadAllVisibleOrganizations(),
                        loadCommunicationChannels()
                    ]).then(function() {
                        loadReviewersDescriptions();
                        return loadGDSNReviewerDescriptions($scope.reviews);
                    }).then(function() {
                        prepareErrorsAndWarnings();
                        $timeout(function() {
                            $scope.loading = false;
                        }, 0);
                      });
                });

        })();

        function prepareErrorsAndWarnings() {
            var reviewEntityAttributes = ['channelId', 'combinedComment', 'comment', 'customValues', 'date',
                'messagingCreatorType', 'primaryKey', 'reviewStatus', 'reviewer', 'supplier', 'supplierId', 'reviewer__'];

            _.forEach($scope.reviews, function (review) {
                _.forEach(review.reviewErrors, function (error) {
                    var sanitizedReview = _.pick(review, reviewEntityAttributes);
                    if ($scope.reviewErrors[error]) {
                        $scope.reviewErrors[error].push(sanitizedReview);
                    } else {
                        $scope.reviewErrors[error] = [sanitizedReview];
                    }
                });

                _.forEach(review.reviewWarnings, function (warning) {
                    var sanitizedReview = _.pick(review, reviewEntityAttributes);
                    if ($scope.reviewWarnings[warning]) {
                        $scope.reviewWarnings[warning].push(sanitizedReview);
                    } else {
                        $scope.reviewWarnings[warning] = [sanitizedReview];
                    }
                });
            });
        }

        function loadReviewersDescriptions() {
            _.forEach($scope.reviews, function(review) {
                getReviewerDescription(review);
            });
        }

        function loadCommunicationChannels() {
            var deferred = $q.defer();

            CommunicationChannelResource.query({},
                function (response) {
                    $scope.channels = response;
                    deferred.resolve();
                },
                function(response){
                    $log.error(response);
                    deferred.resolve();
                });

            return deferred.promise;
        }

        function loadAllVisibleOrganizations() {
            var deferred = $q.defer();

            ContactsResource.query({},
                function (response) {
                    $scope.organizations = response;
                    deferred.resolve();
                },
                function(response) {
                    $log.error(response);
                    deferred.resolve();
                }
            );

            return deferred.promise;
        }

        $scope.toggleErrors = function() {
            $scope.showErrors = !$scope.showErrors;
        };

        $scope.toggleWarnings = function() {
            $scope.showWarnings = !$scope.showWarnings;
        };

        $scope.getCount = function (obj) {
            return _.keys(obj).length;
        };

        $scope.getAggregatedComments = function (reviews) {
            return _.filter(reviews, function(review) {
                return review.combinedComment || review.comment || review.generatedComment;
            });
        };

        $scope.stripHtml = function (html) {
            if (!html || typeof html !== 'string') {
                return html;
            }
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
        };

        function extractPlainSegments(html) {
            if (!html) {
                return [];
            }
            var withBreaks = html
                .replace(/<\s*(hr|br|\/p)\s*\/?>/gi, '\n')
                .replace(/<[^>]+>/g, '');
            var textarea = document.createElement('textarea');
            textarea.innerHTML = withBreaks;
            return textarea.value
                .split('\n')
                .map(function (s) { return s.replace(/^EN:\s*/i, '').trim(); })
                .filter(function (s) { return s.length > 0; });
        }

        function normalizeReviewText(value) {
            if (!value || typeof value !== 'string') {
                return '';
            }
            return $scope.stripHtml(value).replace(/^EN:\s*/i, '').trim();
        }

        function normalizedReviewSegments(html) {
            return extractPlainSegments(html).map(function (segment) {
                return segment.replace(/\s+/g, ' ').trim();
            }).filter(function (segment) {
                return segment.length > 0;
            });
        }

        function longestSegment(segments, accept) {
            var best = '';
            for (var i = 0; i < segments.length; i++) {
                var segment = segments[i];
                if (accept(segment) && segment.length > best.length) {
                    best = segment;
                }
            }
            return best;
        }

        $scope.getReviewMessageKey = function(review, type, index) {
            var reviewerId = review.reviewer__ ? review.reviewer__.id : review.reviewer;
            return review.primaryKey + ':' + reviewerId + ':' + type + ':' + index;
        };

        $scope.isReviewMessageLong = function(message) {
            return message && message.length > REVIEW_MESSAGE_MAX_LENGTH;
        };

        var REVIEW_DESCRIPTION_LINES = 2;
        var REVIEW_TWO_LINE_FALLBACK_CHARS = 160;

        function descriptionExceedsTwoLines(text) {
            if (!text || !String(text).trim()) {
                return false;
            }
            var withBreaks = String(text)
                .replace(/<\s*(hr|br|\/p|\/div|\/li)\s*\/?>/gi, '\n')
                .replace(/<[^>]+>/g, '');
            var parts = withBreaks.split('\n');
            var lines = [];
            for (var i = 0; i < parts.length; i++) {
                var line = parts[i].replace(/\s+/g, ' ').trim();
                if (line.length > 0) {
                    lines.push(line);
                }
            }
            if (lines.length > REVIEW_DESCRIPTION_LINES) {
                return true;
            }
            return lines.join(' ').length > REVIEW_TWO_LINE_FALLBACK_CHARS;
        }

        $scope.needsDescriptionExpand = function(text) {
            return descriptionExceedsTwoLines(text);
        };

        $scope.needsReviewMessageExpand = function(review, shortMessage) {
            return descriptionExceedsTwoLines($scope.getFullReviewMessage(review, shortMessage));
        };

        $scope.isReviewMessageExpanded = function(key) {
            return !!$scope.expandedReviewMessages[key];
        };

        $scope.toggleReviewMessage = function($event, key) {
            $event.preventDefault();
            $scope.expandedReviewMessages[key] = !$scope.expandedReviewMessages[key];
        };

        $scope.getFullReviewMessage = function(review, shortMessage) {
            var plainShort = normalizeReviewText(shortMessage);
            if (!plainShort || !review.combinedComment) {
                return plainShort;
            }

            var segments = normalizedReviewSegments(review.combinedComment);
            var fullPlain = segments.join(' ');
            var longerPrefix = longestSegment(segments, function (segment) {
                return segment.indexOf(plainShort) === 0 && segment.length > plainShort.length;
            });
            if (longerPrefix) {
                return longerPrefix;
            }

            // The stored value spans several comment lines, and the comment continues past it.
            var matchesWholeSegment = false;
            for (var i = 0; i < segments.length; i++) {
                if (segments[i] === plainShort) {
                    matchesWholeSegment = true;
                    break;
                }
            }
            if (fullPlain.indexOf(plainShort) === 0 && fullPlain.length > plainShort.length && !matchesWholeSegment) {
                return fullPlain;
            }

            var probeLength = Math.min(REVIEW_MESSAGE_PROBE_LENGTH, plainShort.length);
            var probe = plainShort.substring(0, probeLength);
            var containing = longestSegment(segments, function (segment) {
                return segment.indexOf(probe) !== -1 && segment.length > plainShort.length;
            });
            if (containing) {
                return containing;
            }

            if (fullPlain.indexOf(probe) !== -1 && fullPlain.length > plainShort.length && !matchesWholeSegment) {
                return fullPlain;
            }

            return plainShort;
        };

        $scope.getFullErrorMessage = function(reviews, shortMessage) {
            if (!reviews || reviews.length === 0) {
                return shortMessage;
            }

            return $scope.getFullReviewMessage(reviews[0], shortMessage);
        };

        $scope.getReviewerName = function(review) {
            if (!_.isEmpty(review.reviewer__.name)) {
                return review.reviewer__.name;
            } else if (!_.isNil($scope.gdsnParties[review.reviewer__.id])){
                return $scope.gdsnParties[review.reviewer__.id].name;
            }

            return null;
        };

        $scope.scrollToComment = function($event, id) {

            $event.preventDefault();

            var commentSectionId = 'comments-' + id;
            var element = document.getElementById(commentSectionId);
            if (!element) {
                return;
            }

            element.scrollIntoView({
                behavior: 'smooth'
            });
            element.classList.add('review-comment-highlighted');
            $timeout(function() {
                element.classList.remove('review-comment-highlighted');
            }, 1000);

        };

        function getReviewerDescription(review) {

            review.reviewer__ = {};

            if (!_.isNil(review.reviewerId)) {
                review.reviewer__.id = review.reviewId;
                var organization = _.find($scope.organizations, function (entry) {
                    // In-platform publications can only exist for organization contacts,
                    // thus we only need to compare the (optional) property 'organizationId'!
                    return entry.organizationId == review.reviewerId;
                });

                if (!_.isNil(organization)) {
                    review.reviewer__.name = organization.name;
                }
            } else {
                review.reviewer__.id = review.reviewer;
                var channel = _.find($scope.channels, function (channel) {
                    if (!_.isNil(channel.subDestinations) && !_.isNil(channel.subDestinations[review.reviewer])) {
                        return true;
                    }
                });

                if (!_.isNil(channel)) {
                    review.reviewer__.name = channel.subDestinations[review.reviewer];
                }
            }
        }

        function loadGDSNReviewerDescriptions(reviews) {
            var idsSet = [];

            _.forEach(reviews, function(review) {
                if (!review.reviewer__.name && review.reviewer__.id.length == GLN_PATTERN_LENGTH) {
                    // We haven't found a name for it, might try with GDSN parties
                    idsSet.push(review.reviewer__.id);
                }
            });

            var deferred = $q.defer();
            getReviewerDescriptionFromGDSNParties(idsSet, function(response) {
                $scope.gdsnParties = _.mapKeys(response, 'gln');
                deferred.resolve();
            });

            return deferred.promise;
        }

        function getReviewerDescriptionFromGDSNParties(ids, callback) {
            GdsnPartiesResource.get({
                gln: ids
            }, function(response) {
                callback(response);
            }, function(error) {
                $log.error(error);
                callback([]);
            });
        }
    }
  );
